export const serviceAreas = [
  { name: "Wake Forest", slug: "web-design-wake-forest-nc" },
  { name: "Youngsville", slug: "web-design-youngsville-nc" },
  { name: "Rolesville", slug: "web-design-rolesville-nc" },
  { name: "Franklinton", slug: "web-design-franklinton-nc" },
  { name: "Zebulon", slug: "web-design-zebulon-nc" },
  { name: "Knightdale", slug: "web-design-knightdale-nc" },
  { name: "Wendell", slug: "web-design-wendell-nc" },
  { name: "Louisburg", slug: "web-design-louisburg-nc" },
  { name: "Raleigh", slug: "web-design-raleigh-nc" },
  { name: "Durham", slug: "web-design-durham-nc" },
  { name: "Cary", slug: "web-design-cary-nc" },
  { name: "Apex", slug: "web-design-apex-nc" },
  { name: "Holly Springs", slug: "web-design-holly-springs-nc" },
  { name: "Fuquay-Varina", slug: "web-design-fuquay-varina-nc" },
  { name: "Garner", slug: "web-design-garner-nc" },
  { name: "Clayton", slug: "web-design-clayton-nc" },
  { name: "Smithfield", slug: "web-design-smithfield-nc" },
  { name: "Henderson", slug: "web-design-henderson-nc" },
  { name: "Oxford", slug: "web-design-oxford-nc" },
  { name: "Creedmoor", slug: "web-design-creedmoor-nc" },
  { name: "Morrisville", slug: null },
  { name: "Chapel Hill", slug: null },
  { name: "Hillsborough", slug: null },
  { name: "Bunn", slug: null },
  { name: "Stem", slug: null },
  { name: "Butner", slug: null },
  { name: "Wilson's Mills", slug: null },
  { name: "Selma", slug: null },
  { name: "Angier", slug: null },
  { name: "Four Oaks", slug: null },
];

export const locations = [
  {
    slug: "web-design-wake-forest-nc",
    city: "Wake Forest",
    state: "NC",
    county: "Wake County",
    latitude: "35.9799",
    longitude: "-78.5097",
    description:
      "Wake Forest is one of the fastest-growing towns in North Carolina — and every local business here needs a website that keeps pace. As a website developer serving Wake Forest, I provide full-service web development, website design, and digital marketing for local businesses. Whether you need a new website built from scratch or want to improve your existing site's SEO and performance, I deliver professional results with fixed pricing and fast turnaround.",
    heroHeadline: "Your Wake Forest customers are searching. Let them find you.",
    heroSubheadline: "Website Development & Web Design in Wake Forest, NC",
    nearbyAreas: ["Youngsville", "Rolesville", "Raleigh", "Durham", "Zebulon", "Knightdale", "Franklinton", "Cary"],
    industries: [
      "Medical Practices", "Law Firms", "Dental Offices", "Restaurants",
      "Real Estate Agents", "Contractors", "Fitness Studios", "Salons & Spas",
      "Insurance Agencies", "Accounting Firms", "Chiropractic Offices", "Veterinarians",
    ],
    metaTitle: "Website Development Wake Forest NC | Web Developer — Trika Studio",
    metaDescription:
      "Professional website development and web design in Wake Forest, NC. Trika Studio is a local website developer building custom websites, SEO, and digital marketing for Wake Forest businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "website development Wake Forest NC, website developer Wake Forest, web design Wake Forest NC, website design Wake Forest NC, web development Wake Forest, website design in Wake Forest, web design in Wake Forest, website development in Wake Forest, Wake Forest web design, Wake Forest web developer, web developer Wake Forest North Carolina, small business website Wake Forest NC",
  },
  {
    slug: "web-design-youngsville-nc",
    city: "Youngsville",
    state: "NC",
    county: "Franklin County",
    latitude: "36.0251",
    longitude: "-78.4744",
    description:
      "Youngsville is a tight-knit, growing community where local businesses thrive — but only when customers can find them online. I provide full-service web development and design for Youngsville businesses, building professional websites that drive real growth.",
    heroHeadline: "Youngsville is growing. Is your business growing with it?",
    heroSubheadline: "Web Design, Development & Marketing in Youngsville, NC",
    nearbyAreas: ["Wake Forest", "Franklinton", "Rolesville", "Louisburg", "Henderson", "Oxford", "Zebulon", "Raleigh"],
    industries: [
      "Healthcare & Medical", "Accounting & Tax", "Chiropractic Offices", "Retail Shops",
      "Home Services", "Wellness & Yoga", "Insurance Agencies", "Restaurants",
      "Hair Salons", "Auto Services", "Real Estate Agents", "Dental Offices",
    ],
    metaTitle: "#1 Web Development & Design in Youngsville NC | Trika Studio",
    metaDescription:
      "Top web development company in Youngsville, NC. Locally based web developer building custom websites, SEO, and digital marketing for Franklin County small businesses. Fixed pricing from $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web development Youngsville NC, web design Youngsville NC, web developer Youngsville, website development Youngsville North Carolina, top web development Youngsville, Franklin County web development, Youngsville web design company, small business website Youngsville NC",
  },
  {
    slug: "web-design-rolesville-nc",
    city: "Rolesville",
    state: "NC",
    county: "Wake County",
    latitude: "35.9235",
    longitude: "-78.4575",
    description:
      "Rolesville is one of Wake County's fastest-growing communities. Local businesses here need a strong digital presence to stand out in a competitive market. I build websites that rank locally and convert visitors into paying customers.",
    heroHeadline: "Rolesville businesses deserve more than a template.",
    heroSubheadline: "Web Design, Development & Marketing in Rolesville, NC",
    nearbyAreas: ["Wake Forest", "Youngsville", "Zebulon", "Raleigh", "Knightdale", "Wendell", "Franklinton", "Durham"],
    industries: [
      "Dental Offices", "Contractors", "Fitness Studios", "Salons & Spas",
      "Retail Shops", "Medical Practices", "Childcare Centers", "Real Estate Agents",
      "Home Services", "Restaurants", "Law Firms", "Insurance Agencies",
    ],
    metaTitle: "Web Design Rolesville NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and development in Rolesville, NC. Trika Studio builds professional websites for Wake County businesses. Fixed pricing. Fast delivery. Call (919) 229-5525.",
    metaKeywords:
      "web design Rolesville NC, website design Rolesville, web developer Rolesville North Carolina, website development Rolesville NC, website developer Rolesville, Wake County web design, Wake County web development",
  },
  {
    slug: "web-design-franklinton-nc",
    city: "Franklinton",
    state: "NC",
    county: "Franklin County",
    latitude: "36.1010",
    longitude: "-78.4581",
    description:
      "Franklinton businesses deserve a web presence that reflects their quality. Whether you're a law firm, medical practice, or local shop, I build professional websites that help Franklinton businesses compete and grow.",
    heroHeadline: "Put your Franklinton business on the digital map.",
    heroSubheadline: "Web Design, Development & Marketing in Franklinton, NC",
    nearbyAreas: ["Youngsville", "Louisburg", "Wake Forest", "Oxford", "Henderson", "Creedmoor", "Rolesville", "Durham"],
    industries: [
      "Law Firms", "Medical Practices", "Agriculture & Farm Supply", "Home Services",
      "Nonprofits", "Dental Offices", "Retail Shops", "Contractors",
      "Insurance Agencies", "Hair Salons", "Auto Services", "Accounting Firms",
    ],
    metaTitle: "Web Design Franklinton NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Franklinton, NC. Trika Studio builds modern websites for Franklin County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Franklinton NC, website design Franklinton, web developer Franklinton North Carolina, website development Franklinton NC, website developer Franklinton, Franklin County web developer, Franklin County web development",
  },
  {
    slug: "web-design-zebulon-nc",
    city: "Zebulon",
    state: "NC",
    county: "Wake County",
    latitude: "35.8243",
    longitude: "-78.3148",
    description:
      "Zebulon is a growing Wake County town with a vibrant small business community. I help Zebulon businesses build websites that get found on Google and turn online visitors into loyal local customers.",
    heroHeadline: "Zebulon is booming. Your online presence should be too.",
    heroSubheadline: "Web Design, Development & Marketing in Zebulon, NC",
    nearbyAreas: ["Wendell", "Knightdale", "Rolesville", "Wilson's Mills", "Clayton", "Selma", "Smithfield", "Wake Forest"],
    industries: [
      "Auto Services", "Restaurants", "Contractors", "Retail Shops",
      "Healthcare & Medical", "Fitness Studios", "Hair Salons", "Law Firms",
      "Home Services", "Dental Offices", "Insurance Agencies", "Real Estate Agents",
    ],
    metaTitle: "Web Design Zebulon NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and development in Zebulon, NC. Trika Studio builds professional websites for Wake County small businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Zebulon NC, website design Zebulon, web developer Zebulon North Carolina, website development Zebulon NC, website developer Zebulon, Wake County web design Zebulon",
  },
  {
    slug: "web-design-knightdale-nc",
    city: "Knightdale",
    state: "NC",
    county: "Wake County",
    latitude: "35.7879",
    longitude: "-78.4897",
    description:
      "Knightdale is one of Raleigh's fastest-growing suburbs. With more residents and businesses moving in every year, standing out online has never been more important. I build clean, fast websites that put Knightdale businesses on the map.",
    heroHeadline: "Stand out in Knightdale's competitive market.",
    heroSubheadline: "Web Design, Development & Marketing in Knightdale, NC",
    nearbyAreas: ["Zebulon", "Wendell", "Raleigh", "Garner", "Clayton", "Smithfield", "Rolesville", "Durham"],
    industries: [
      "Real Estate Agents", "Medical Practices", "Fitness Studios", "Restaurants",
      "Law Firms", "Dental Offices", "Contractors", "Retail Shops",
      "Hair Salons", "Childcare Centers", "Insurance Agencies", "Accounting Firms",
    ],
    metaTitle: "Web Design Knightdale NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Knightdale, NC. Trika Studio builds fast, modern websites for Wake County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Knightdale NC, website design Knightdale, web developer Knightdale North Carolina, website development Knightdale NC, website developer Knightdale, Knightdale small business website",
  },
  {
    slug: "web-design-wendell-nc",
    city: "Wendell",
    state: "NC",
    county: "Wake County",
    latitude: "35.7810",
    longitude: "-78.3697",
    description:
      "Wendell's small business community is strong — but without a professional website, local customers often can't find you. I help Wendell business owners build affordable, high-quality websites that generate real leads.",
    heroHeadline: "Wendell businesses: get found by customers who need you.",
    heroSubheadline: "Web Design, Development & Marketing in Wendell, NC",
    nearbyAreas: ["Zebulon", "Knightdale", "Rolesville", "Smithfield", "Clayton", "Garner", "Raleigh", "Selma"],
    industries: [
      "Home Services", "Salons & Spas", "Contractors", "Retail Shops",
      "Agriculture & Farming", "Restaurants", "Auto Services", "Childcare Centers",
      "Medical Practices", "Dental Offices", "Real Estate Agents", "Fitness Studios",
    ],
    metaTitle: "Web Design Wendell NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and development in Wendell, NC. Trika Studio builds professional websites for Wake County small businesses. Affordable fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Wendell NC, website design Wendell, web developer Wendell North Carolina, website development Wendell NC, website developer Wendell, Wake County web design Wendell",
  },
  {
    slug: "web-design-louisburg-nc",
    city: "Louisburg",
    state: "NC",
    county: "Franklin County",
    latitude: "36.0990",
    longitude: "-78.3014",
    description:
      "As Franklin County's seat, Louisburg has a rich local business community that deserves a professional online presence. I build modern, SEO-optimized websites for Louisburg businesses that attract new customers and build lasting trust.",
    heroHeadline: "Give your Louisburg business the online presence it deserves.",
    heroSubheadline: "Web Design, Development & Marketing in Louisburg, NC",
    nearbyAreas: ["Franklinton", "Youngsville", "Henderson", "Oxford", "Bunn", "Creedmoor", "Wake Forest", "Durham"],
    industries: [
      "Legal Services", "Medical Practices", "Dental Offices", "Retail Shops",
      "Education & Tutoring", "Nonprofits", "Accounting Firms", "Insurance Agencies",
      "Contractors", "Hair Salons", "Auto Services", "Agriculture & Farm Supply",
    ],
    metaTitle: "Web Design Louisburg NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Louisburg, NC. Trika Studio builds modern websites for Franklin County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Louisburg NC, website design Louisburg, web developer Louisburg North Carolina, website development Louisburg NC, website developer Louisburg, Franklin County web designer, Franklin County web development",
  },
  {
    slug: "web-design-raleigh-nc",
    city: "Raleigh",
    state: "NC",
    county: "Wake County",
    latitude: "35.7796",
    longitude: "-78.6382",
    description:
      "Raleigh is North Carolina's capital and one of the fastest-growing tech hubs in the country. With thousands of small businesses competing for attention, a professional website isn't optional — it's essential. I build high-performance websites and run digital marketing campaigns that help Raleigh businesses stand out.",
    heroHeadline: "Raleigh is competitive. Your website should be too.",
    heroSubheadline: "Web Design, Development & Marketing in Raleigh, NC",
    nearbyAreas: ["Cary", "Garner", "Knightdale", "Wake Forest", "Apex", "Durham", "Morrisville", "Holly Springs"],
    industries: [
      "Tech Startups", "Law Firms", "Medical Practices", "Restaurants",
      "Real Estate Agents", "Contractors", "Fitness Studios", "Salons & Spas",
      "Insurance Agencies", "Accounting Firms", "Dental Offices", "Consulting Firms",
    ],
    metaTitle: "Web Design Raleigh NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design and digital marketing in Raleigh, NC. Custom websites, SEO, and Google Ads for local businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Raleigh NC, website design Raleigh, web developer Raleigh North Carolina, website development Raleigh NC, website developer Raleigh, Raleigh web design company, Raleigh web development, small business website Raleigh",
  },
  {
    slug: "web-design-durham-nc",
    city: "Durham",
    state: "NC",
    county: "Durham County",
    latitude: "35.9940",
    longitude: "-78.8986",
    description:
      "Durham's business scene is thriving — from the American Tobacco Campus to the startups on Main Street. Whether you're a Bull City restaurant, healthcare practice, or growing startup, I build websites that reflect Durham's creative energy and drive real business results.",
    heroHeadline: "Build a website as ambitious as your Durham business.",
    heroSubheadline: "Web Design, Development & Marketing in Durham, NC",
    nearbyAreas: ["Raleigh", "Chapel Hill", "Hillsborough", "Morrisville", "Cary", "Wake Forest", "Creedmoor", "Butner"],
    industries: [
      "Tech Startups", "Restaurants & Breweries", "Healthcare & Medical", "Law Firms",
      "Nonprofits", "Real Estate Agents", "Fitness Studios", "Consulting Firms",
      "Dental Offices", "Retail Shops", "Education", "Creative Agencies",
    ],
    metaTitle: "Web Design Durham NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Durham, NC. Trika Studio builds custom websites for Bull City businesses. Fixed pricing. Fast delivery. Call (919) 229-5525.",
    metaKeywords:
      "web design Durham NC, website design Durham, web developer Durham North Carolina, website development Durham NC, website developer Durham, Durham web design, Durham web development, Bull City web developer",
  },
  {
    slug: "web-design-cary-nc",
    city: "Cary",
    state: "NC",
    county: "Wake County",
    latitude: "35.7915",
    longitude: "-78.7811",
    description:
      "Cary consistently ranks as one of the best places to live in America — and its business community reflects that quality. I help Cary businesses build polished, professional websites that match the high standards their customers expect.",
    heroHeadline: "Cary businesses set a high bar. Your website should too.",
    heroSubheadline: "Web Design, Development & Marketing in Cary, NC",
    nearbyAreas: ["Raleigh", "Apex", "Morrisville", "Holly Springs", "Durham", "Garner", "Fuquay-Varina", "Wake Forest"],
    industries: [
      "Medical Practices", "Dental Offices", "Law Firms", "Financial Advisors",
      "Real Estate Agents", "Restaurants", "Fitness Studios", "Salons & Spas",
      "Consulting Firms", "Insurance Agencies", "Contractors", "Retail Shops",
    ],
    metaTitle: "Web Design Cary NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Cary, NC. Trika Studio builds custom, SEO-optimized websites for Cary businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Cary NC, website design Cary, web developer Cary North Carolina, website development Cary NC, website developer Cary, Cary NC web design, Cary web development, small business website Cary",
  },
  {
    slug: "web-design-apex-nc",
    city: "Apex",
    state: "NC",
    county: "Wake County",
    latitude: "35.7327",
    longitude: "-78.8503",
    description:
      "Known as 'the Peak of Good Living,' Apex is one of the Triangle's most desirable towns. Local businesses here benefit from an affluent, educated customer base — but you need a professional online presence to capture them. I build websites that convert Apex visitors into customers.",
    heroHeadline: "The Peak of Good Living deserves peak web design.",
    heroSubheadline: "Web Design, Development & Marketing in Apex, NC",
    nearbyAreas: ["Cary", "Holly Springs", "Fuquay-Varina", "Raleigh", "Morrisville", "Garner", "Durham", "Angier"],
    industries: [
      "Dental Offices", "Medical Practices", "Real Estate Agents", "Restaurants",
      "Fitness Studios", "Law Firms", "Financial Advisors", "Contractors",
      "Salons & Spas", "Insurance Agencies", "Retail Shops", "Consulting Firms",
    ],
    metaTitle: "Web Design Apex NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Apex, NC. Trika Studio builds custom websites for Wake County businesses. Fixed pricing. Fast delivery. Call (919) 229-5525.",
    metaKeywords:
      "web design Apex NC, website design Apex, web developer Apex North Carolina, website development Apex NC, website developer Apex, Apex NC web design",
  },
  {
    slug: "web-design-holly-springs-nc",
    city: "Holly Springs",
    state: "NC",
    county: "Wake County",
    latitude: "35.6513",
    longitude: "-78.8336",
    description:
      "Holly Springs has exploded in growth over the past decade, with new businesses opening every month. Standing out in this rapidly expanding market requires a website that's fast, professional, and optimized for local search. That's exactly what I build.",
    heroHeadline: "Holly Springs is growing fast. Is your business keeping up?",
    heroSubheadline: "Web Design, Development & Marketing in Holly Springs, NC",
    nearbyAreas: ["Apex", "Fuquay-Varina", "Cary", "Angier", "Garner", "Raleigh", "Clayton", "Morrisville"],
    industries: [
      "Medical Practices", "Dental Offices", "Restaurants", "Fitness Studios",
      "Real Estate Agents", "Contractors", "Childcare Centers", "Salons & Spas",
      "Insurance Agencies", "Retail Shops", "Law Firms", "Veterinarians",
    ],
    metaTitle: "Web Design Holly Springs NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Holly Springs, NC. Trika Studio builds modern, SEO-optimized websites for local businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Holly Springs NC, website design Holly Springs, web developer Holly Springs North Carolina, website development Holly Springs NC, website developer Holly Springs, Holly Springs web design",
  },
  {
    slug: "web-design-fuquay-varina-nc",
    city: "Fuquay-Varina",
    state: "NC",
    county: "Wake County",
    latitude: "35.5843",
    longitude: "-78.8001",
    description:
      "Fuquay-Varina's charming downtown and growing population make it a prime spot for local businesses. But without a professional website, potential customers drive right past. I build websites that put Fuquay-Varina businesses on the digital map.",
    heroHeadline: "Put your Fuquay-Varina business on the digital map.",
    heroSubheadline: "Web Design, Development & Marketing in Fuquay-Varina, NC",
    nearbyAreas: ["Holly Springs", "Apex", "Angier", "Garner", "Clayton", "Raleigh", "Cary", "Four Oaks"],
    industries: [
      "Restaurants & Breweries", "Contractors", "Real Estate Agents", "Salons & Spas",
      "Auto Services", "Medical Practices", "Dental Offices", "Retail Shops",
      "Fitness Studios", "Insurance Agencies", "Home Services", "Childcare Centers",
    ],
    metaTitle: "Web Design Fuquay-Varina NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Fuquay-Varina, NC. Trika Studio builds professional websites for local businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Fuquay-Varina NC, website design Fuquay-Varina, web developer Fuquay-Varina North Carolina, website development Fuquay-Varina NC, website developer Fuquay-Varina",
  },
  {
    slug: "web-design-garner-nc",
    city: "Garner",
    state: "NC",
    county: "Wake County",
    latitude: "35.7113",
    longitude: "-78.6142",
    description:
      "Garner is a growing community just south of Raleigh with a strong small business presence. I help Garner businesses build professional websites that attract local customers and compete with the larger Raleigh market next door.",
    heroHeadline: "Garner businesses: compete with Raleigh online.",
    heroSubheadline: "Web Design, Development & Marketing in Garner, NC",
    nearbyAreas: ["Raleigh", "Clayton", "Knightdale", "Fuquay-Varina", "Smithfield", "Cary", "Holly Springs", "Apex"],
    industries: [
      "Contractors", "Auto Services", "Restaurants", "Medical Practices",
      "Dental Offices", "Real Estate Agents", "Hair Salons", "Retail Shops",
      "Insurance Agencies", "Fitness Studios", "Home Services", "Law Firms",
    ],
    metaTitle: "Web Design Garner NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Garner, NC. Trika Studio builds fast, modern websites for Wake County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Garner NC, website design Garner, web developer Garner North Carolina, website development Garner NC, website developer Garner, Garner web design",
  },
  {
    slug: "web-design-clayton-nc",
    city: "Clayton",
    state: "NC",
    county: "Johnston County",
    latitude: "35.6507",
    longitude: "-78.4564",
    description:
      "Clayton is one of Johnston County's fastest-growing towns, attracting new residents and businesses alike. I build professional websites that help Clayton businesses capture this growing market and stand out from competitors.",
    heroHeadline: "Clayton is booming. Your online presence should be too.",
    heroSubheadline: "Web Design, Development & Marketing in Clayton, NC",
    nearbyAreas: ["Garner", "Smithfield", "Knightdale", "Raleigh", "Selma", "Four Oaks", "Fuquay-Varina", "Wendell"],
    industries: [
      "Contractors", "Restaurants", "Medical Practices", "Real Estate Agents",
      "Auto Services", "Dental Offices", "Fitness Studios", "Retail Shops",
      "Home Services", "Insurance Agencies", "Hair Salons", "Childcare Centers",
    ],
    metaTitle: "Web Design Clayton NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Clayton, NC. Trika Studio builds professional websites for Johnston County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Clayton NC, website design Clayton, web developer Clayton North Carolina, website development Clayton NC, website developer Clayton, Johnston County web design, Johnston County web development",
  },
  {
    slug: "web-design-smithfield-nc",
    city: "Smithfield",
    state: "NC",
    county: "Johnston County",
    latitude: "35.5085",
    longitude: "-78.3395",
    description:
      "As Johnston County's county seat, Smithfield has a strong local business community anchored by downtown shops, restaurants, and professional services. I build modern websites that help Smithfield businesses grow and attract customers from across the region.",
    heroHeadline: "Give your Smithfield business a website that works as hard as you do.",
    heroSubheadline: "Web Design, Development & Marketing in Smithfield, NC",
    nearbyAreas: ["Clayton", "Selma", "Four Oaks", "Garner", "Wendell", "Knightdale", "Raleigh", "Zebulon"],
    industries: [
      "Law Firms", "Medical Practices", "Restaurants", "Retail Shops",
      "Contractors", "Auto Services", "Dental Offices", "Insurance Agencies",
      "Real Estate Agents", "Agriculture & Farm Supply", "Hair Salons", "Accounting Firms",
    ],
    metaTitle: "Web Design Smithfield NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Smithfield, NC. Trika Studio builds modern websites for Johnston County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Smithfield NC, website design Smithfield, web developer Smithfield North Carolina, website development Smithfield NC, website developer Smithfield, Johnston County web developer, Johnston County web development",
  },
  {
    slug: "web-design-henderson-nc",
    city: "Henderson",
    state: "NC",
    county: "Vance County",
    latitude: "36.3293",
    longitude: "-78.3992",
    description:
      "Henderson is the heart of Vance County, with a close-knit business community that's ready for digital growth. I help Henderson businesses build professional websites that bring in new customers and establish credibility online.",
    heroHeadline: "Henderson businesses deserve a professional online presence.",
    heroSubheadline: "Web Design, Development & Marketing in Henderson, NC",
    nearbyAreas: ["Oxford", "Louisburg", "Franklinton", "Creedmoor", "Youngsville", "Wake Forest", "Durham", "Butner"],
    industries: [
      "Medical Practices", "Law Firms", "Restaurants", "Retail Shops",
      "Auto Services", "Contractors", "Insurance Agencies", "Dental Offices",
      "Nonprofits", "Agriculture & Farm Supply", "Hair Salons", "Real Estate Agents",
    ],
    metaTitle: "Web Design Henderson NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Henderson, NC. Trika Studio builds professional websites for Vance County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Henderson NC, website design Henderson, web developer Henderson North Carolina, website development Henderson NC, website developer Henderson, Vance County web design, Vance County web development",
  },
  {
    slug: "web-design-oxford-nc",
    city: "Oxford",
    state: "NC",
    county: "Granville County",
    latitude: "36.3107",
    longitude: "-78.5911",
    description:
      "Oxford is Granville County's county seat with a charming historic downtown and growing business community. I build modern, professional websites that help Oxford businesses reach more customers and compete in the digital age.",
    heroHeadline: "Bring your Oxford business into the digital age.",
    heroSubheadline: "Web Design, Development & Marketing in Oxford, NC",
    nearbyAreas: ["Henderson", "Creedmoor", "Butner", "Stem", "Franklinton", "Louisburg", "Durham", "Wake Forest"],
    industries: [
      "Law Firms", "Medical Practices", "Restaurants", "Retail Shops",
      "Contractors", "Agriculture & Farm Supply", "Insurance Agencies", "Dental Offices",
      "Auto Services", "Nonprofits", "Real Estate Agents", "Accounting Firms",
    ],
    metaTitle: "Web Design Oxford NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Professional web design in Oxford, NC. Trika Studio builds modern websites for Granville County businesses. Fixed pricing starting at $1,200. Call (919) 229-5525.",
    metaKeywords:
      "web design Oxford NC, website design Oxford, web developer Oxford North Carolina, website development Oxford NC, website developer Oxford, Granville County web design, Granville County web development",
  },
  {
    slug: "web-design-creedmoor-nc",
    city: "Creedmoor",
    state: "NC",
    county: "Granville County",
    latitude: "36.1224",
    longitude: "-78.6861",
    description:
      "Creedmoor is a small but growing town between Durham and the Virginia border. Local businesses here need an online presence to capture both local customers and travelers passing through. I build websites that work for Creedmoor's unique market.",
    heroHeadline: "Small town, big potential. Let's build your online presence.",
    heroSubheadline: "Web Design, Development & Marketing in Creedmoor, NC",
    nearbyAreas: ["Oxford", "Butner", "Stem", "Durham", "Franklinton", "Youngsville", "Wake Forest", "Henderson"],
    industries: [
      "Contractors", "Auto Services", "Restaurants", "Retail Shops",
      "Home Services", "Medical Practices", "Agriculture & Farm Supply", "Hair Salons",
      "Real Estate Agents", "Insurance Agencies", "Dental Offices", "Veterinarians",
    ],
    metaTitle: "Web Design Creedmoor NC | Trika Studio — Web Design & Development",
    metaDescription:
      "Web design and digital marketing in Creedmoor, NC. Trika Studio builds professional websites for Granville County businesses. Fixed pricing. Call (919) 229-5525.",
    metaKeywords:
      "web design Creedmoor NC, website design Creedmoor, web developer Creedmoor North Carolina, website development Creedmoor NC, website developer Creedmoor, Granville County web developer, Granville County web development",
  },
];
